export const POLYGON_CHAIN_ID  = 137;
export const AMOY_CHAIN_ID     = 80002;
export const ALLOWED_CHAIN_IDS = [POLYGON_CHAIN_ID];

export const CONTRACT_OWNER_ADDRESS = "0x6D48faA7b029342341659be3A483b8f2a8c5260F";

// Reliable Polygon RPC — publicnode is stable and free
export const POLYGON_RPC_URL =
  (import.meta as any).env?.VITE_POLYGON_RPC ?? "https://polygon-bor-rpc.publicnode.com";

export function getNetworkName(chainId: number): string {
  if (chainId === POLYGON_CHAIN_ID) return "Polygon";
  if (chainId === AMOY_CHAIN_ID)    return "Polygon Amoy";
  return `Chain ${chainId}`;
}
